export const home = {
  soon: "Próximamente",
  soonLaunch: "Araria está en beta.",
  hero: {
    title: "Todos los Modelos Premium de IA en un solo lugar",
    subtitle:
      "¿Por qué pagar varias suscripciones? Tené acceso a GPT-4, Claude, Gemini, Generación de Imágenes y Videos y más en una única plataforma.",
    cta: "Precios",
    titleBottom: "¡Comenzá gratis ahora mismo!",
    titleBottomDescription:
      "El plan Free no requiere tarjeta de crédito, los modelos gratuitos son:",
  },
  providers: {
    title: "Accedé a los Principales Proveedores de IA",
    subtitle:
      "Una plataforma, múltiples modelos de IA de vanguardia a tu alcance",
    openai: "OpenAI",
    anthropic: "Anthropic",
    google: "Google",
    mistral: "Mistral AI",
    deepseek: "DeepSeek",
    meta: "Meta AI",
    groq: "Groq",
    maritaca: "Maritaca AI",
    alibaba: "Alibaba",
    midjourney: "MidJourney",
    perplexity: "Perplexity",
    flux: "Flux",
    stabilityai: "Stability AI",
    ollama: "Ollama",
    runway: "Runway",
    runware: "Runware",
    playht: "PlayHT",
    decor8: "Decor8",
    civitai: "CivitAI",
    mxbai: "Mixedbread AI",
    cohere: "Cohere AI",
    suno: "Suno",
    kling: "Kling AI",
    viewModels: "Ver Modelos",
    whatsapp: "WhatsApp",
    twilio: "Twilio",
    contentful: "Contentful",
  },
  thirdParty: {
    title: "Integraciones Third Party",
    subtitle: "Conoce algunas de nuestras integraciones oficiales",
  },
  typeAnimationFeatures: [
    {
      title:
        "¿No te gustó la respuesta de ChatGPT/Claude/Gemini? ¡Probá tu conversación con varios modelos usando reprompt rápido!",
    },
    {
      title: "¿Querés crear videos? ¡Usá Kling AI, Runway, Hailuo y Luma!",
    },
    {
      title:
        "¿Generación de imágenes de primera línea? 🦄 ¡Usá CivitAI, Flux y MidJourney con precios súper competitivos!",
    },
    {
      title:
        "¿Necesitás una banda sonora o música para tu proyecto? 🎶 ¡Usá Suno y Udio!",
    },
    {
      title:
        "¿Qué tal crear personas con IA y charlar con Gandhi al estilo Character.AI?",
    },
    {
      title:
        "¿Tu chatbot es flojo? Experimentá usando nuestros Agentes con herramienta de scraping y base de conocimiento 🔥",
    },
    {
      title:
        "🦸 ¡Dale Super Poderes a tus Agentes con herramientas para que tu agente maneje diversos desafíos!",
    },
    {
      title:
        "Hay tantas cosas que se pueden hacer por acá, usá las Carpetas para organizar tus chats y generaciones 😜",
    },
    {
      title:
        "¿Necesitás descubrir qué modelo de IA es mejor para tu desafío? ¡Compará resultados lado a lado!",
    },
    {
      title:
        "¿Necesitás un chatbot para tu sitio web o tienda? ¡Usá el Embed de Agentes para conectarlo rapidito!",
    },
    {
      title:
        "Comenzá a usar Araria a partir de R$ 36,00 de depósito, sin suscripción, sin compromiso, no expira.",
    },
    {
      title:
        "¿Necesitás una solución personalizada para tu negocio? Integramos con cualquier sistema, CRM, ERP, APIs, etc.",
    },
    {
      title:
        "¿Tu sistema o sitio web necesita inteligencia? 🔮 Usá nuestra API, ponemos a disposición endpoints para que te conectes con Araria.",
    },
    {
      title:
        "Además de nuestra API, ¿sabías que también tenemos SDK? ¡Mirá nuestros SDKs para NodeJS y Python en GitHub!",
    },
  ],
  features: {
    title: "Potenciá tu flujo de trabajo con IA",
    subtitle:
      "Desbloqueá todo el potencial de la IA con nuestro conjunto completo de funciones",
    reprompting: {
      title: "Reprompt Rápido",
      description:
        "Enviá rápidamente tu prompt a otro modelo para obtener un resultado diferente y beneficiate de la diversidad de posibles respuestas.",
    },
    upload: {
      title: "Subida de Imágenes y Documentos",
      description:
        "Subí y analizá imágenes o documentos fácilmente, permitiendo que la IA procese información visual y extraiga insights.",
    },
    devices: {
      title: "Múltiples dispositivos",
      description:
        "Accedé a la aplicación desde cualquier dispositivo: Android, iPhone y Escritorio. Acceso rápido desde la barra de tareas o el teléfono.",
    },
    history: {
      title: "Historial de Chat",
      description:
        "Accedé y revisá conversaciones anteriores, permitiendo la continuidad en las discusiones y una fácil referencia a información anterior.",
    },
    multilingual: {
      title: "Modelos Multilingües",
      description:
        "Comunicate y generá contenido en varios idiomas, rompiendo barreras lingüísticas y expandiendo la usabilidad global.",
    },
    folders: {
      title: "Carpetas",
      description:
        "Organizá tus chats y generaciones en carpetas para facilitar la navegación y la búsqueda de conversaciones específicas.",
    },
    sideBySide: {
      title: "Conversación en Paralelo", // More descriptive than "Lateral"
      description:
        "Conversá con varios modelos de IA al mismo tiempo, para comparar resultados y elegir el mejor modelo para tu tarea.",
    },
    memory: {
      title: "Memoria",
      description:
        "Controlá cuánta memoria se usa como contexto para optimizar tus necesidades, balanceando entre rendimiento y costo.",
    },
    slides: {
      title: "Diapositivas",
      description:
        "Generá presentaciones de diapositivas con IA, permitiéndote crear contenido visual para tus proyectos o uso personal/comercial.",
    },
    image: {
      title: "Generación de Imágenes",
      description:
        "Generá imágenes usando más de 200 mil modelos de CivitAI y Flux, controles avanzados y manipulación de imágenes.",
    },
    api: {
      title: "API",
      description:
        "Integrá fácilmente Araria en los procesos y sistemas de tu empresa, con una API diversa y precios justos.",
    },
    agents: {
      title: "Agentes de IA",
      description:
        "Creá y gestioná agentes de IA para diferentes contextos y tareas complejas, integraciones y herramientas para la automatización.",
    },
    video: {
      title: "Generación de Videos",
      description:
        "Generá videos con una diversidad de proveedores para que crees contenido visual para tus proyectos o uso personal/comercial.",
    },
    characters: {
      title: "Personajes",
      description:
        "Creá personajes/especialistas con IA, permitiendo interacciones especializadas con tu toque, tono y base de conocimiento.",
    },
    users: {
      title: "Usuarios",
      description:
        "Gestioná sub-usuarios que pueden utilizar tus agentes propietarios, creá accesos exclusivos para tus agentes especialistas.",
    },
    tools: {
      title: "Herramientas",
      description:
        "Dale superpoderes a tus agentes con diversas herramientas, como integraciones con SERP, Geocoding, Web Search, Scraping y más.",
    },
  },
  futureFeatures: {
    title: "En desarrollo",
    subtitle:
      "¡Estamos trabajando constantemente para mejorar Araria y brindarte la mejor experiencia en IA!",
    imageGeneration: {
      title: "Generación de Imágenes",
      description:
        "Generá imágenes usando modelos de IA, permitiéndote crear contenido visual para tus proyectos o uso personal/comercial.",
    },
    videoGeneration: {
      title: "Generación de Videos",
      description:
        "Generá videos con una diversidad de proveedores para que crees contenido visual para tus proyectos o uso personal/comercial.",
    },
    assistant: {
      title: "Asistente de Proyecto",
      description:
        "Configurá tu asistente de IA ideal proporcionando un contexto, para que pueda ayudarte mejor en tu proyecto o tarea diaria.",
    },
    agents: {
      title: "Agentes de IA",
      description:
        "Creá y gestioná agentes de IA para diferentes contextos y tareas complejas, integraciones con servicios de terceros y herramientas para automatizar tu flujo de trabajo.",
    },
    enterpriseAPI: {
      title: "API Empresarial",
      description:
        "Accedé a nuestra API para llamadas en volumen, reduciendo la complejidad de la integración con múltiples proveedores y herramientas de IA.",
    },
    training: {
      title: "Entrenamiento de Modelos",
      description:
        "Entrená modelos de IA personalizados para satisfacer tus necesidades específicas.",
    },
    speech: {
      title: "Conversación con IA",
      description:
        "Conversá con IA usando voz y texto, permitiéndote interactuar con la IA de manera natural.",
    },
  },
  gallery: {
    title: "Generación de Imágenes",
    subtitle:
      "¡Elegí entre una diversidad de modelos de generación de imágenes!",
  },
  video: {
    title: "Generación de Videos",
    subtitle: "Generá nuevos videos con texto, imágenes o videoclips",
    feature1: {
      title: "Plantilla de prompt", // Keeping "Prompt template"
      description:
        "Elegí plantillas de prompts apropiadas para la generación de videos",
    },
    feature2: {
      title: "Primero y último", // Could also be "Inicio y fin"
      description: "Elegí a partir de dónde generar tu video",
    },
    feature3: {
      title: "Duración de Videos",
      description: "Elegí la duración del video que querés generar (5-10s)",
    },
  },
  agentChat: {
    title: "¿Tenés dudas?",
    subtitle: "Preguntale a nuestra asistente de IA, ¡ella sabe todo!",
    button: "Chat",
  },
  faq: {
    title: "¿Tenés dudas?",
    subtitle: "Preguntas Frecuentes",
    questions: {
      models: {
        question: "¿Cuáles son los modelos de IA disponibles actualmente?",
        answer:
          "Las versiones actuales de los modelos disponibles en Araria incluyen GPT-4, Claude 3.5 Sonnet, Gemini 2.0 Flash, Llama 3.3 70B, y Mistral Large 2. Actualizamos continuamente nuestra selección de modelos para proporcionar la mejor experiencia en IA.",
      },
      selection: {
        question: "¿Cómo seleccionan los modelos de IA?",
        answer:
          "Seleccionamos cuidadosamente los mejores modelos de IA en base a benchmarks de rendimiento, incluyendo comparadores abiertos de LLM como lmsys.org y estudios universitarios como Berkeley Function Calling Leaderboard y livebench.ai.",
      },
      assistants: {
        question: "¿Qué son los Asistentes de Proyecto?",
        answer:
          "Un Asistente de Proyecto es una IA personalizada a la que le proporcionás conocimiento específico. Así, puede responder tus preguntas diarias sin la necesidad de repetir el contexto. Podés comparar el rendimiento de tus asistentes en diferentes modelos con un clic.",
      },
      availability: {
        question: "¿Puedo acceder a todos los modelos desde cualquier lugar?",
        answer:
          "Proporcionamos acceso a modelos premium de IA usando APIs oficiales. Algunos modelos pueden tener restricciones regionales basadas en las políticas de los proveedores. Araria funciona en servidores de borde más cercanos a tu ubicación para un rendimiento óptimo.",
      },
      tokenCount: {
        question: "¿Cuántos caracteres tiene un token?",
        answer:
          "La cantidad de caracteres en un token varía según el modelo y el idioma, pero generalmente un token es equivalente a una palabra (o 4-7 caracteres por token).",
      },
    },
  },
};
